if (!customElements.get('ca-footer-navigation')) {
  customElements.define('ca-footer-navigation', class extends HTMLElement {
    connectedCallback() {
      this.disclosures = [...this.querySelectorAll('.ca-footer__disclosure')];
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.syncLayout = () => {
        this.disclosures.forEach(disclosure => {
          disclosure.open = !this.mobile.matches;
          const summary = disclosure.querySelector('summary');
          if (this.mobile.matches) {
            summary.removeAttribute('tabindex');
            summary.removeAttribute('aria-disabled');
          } else {
            summary.setAttribute('tabindex', '-1');
            summary.setAttribute('aria-disabled', 'true');
          }
        });
      };
      this.onClick = event => {
        if (!this.mobile.matches && event.target.closest('summary')) event.preventDefault();
      };
      this.addEventListener('click', this.onClick);
      this.mobile.addEventListener('change', this.syncLayout);
      this.syncLayout();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.mobile?.removeEventListener('change', this.syncLayout);
    }
  });
}
